import React, { useRef, useState } from 'react'

const UploadImage = ({ setFile, file, fileType }) => {
    const [dragActive, setDragActive] = useState(false)
    const inputFile = useRef(null)

    const handleDrag = (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (e.type === 'dragenter' || e.type === 'dragover') {
            setDragActive(true)
        } else if (e.type === 'dragleave') {
            setDragActive(false)
        }
    }

    const handleDrop = (e) => {
        const { files } = e.dataTransfer
        e.preventDefault()
        e.stopPropagation()
        setDragActive(false)
        if (files && files.length) {
            setFile([...file, files[0]])
        }
    }

    const handleUploadClick = (e) => {
        const { files } = e.target
        if (files && files.length) {
            setFile([...file, files[0]])
        }
    }

    const onButtonClick = () => {
        inputFile.current.click()
    }

    return (
        <div
            style={{ cursor: 'pointer', border: '1px solid var(--grey-100, #ccc)' }}
            className={`d-flex flex-column w-100 align-items-center justify-content-center gap-3 rounded p-5 ${
                dragActive ? 'bg-gray' : ''
            }`}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}
            onClick={onButtonClick}
        >
            <img
                src="/svgs/modal-icons/modal-file-icon.svg"
                alt="file-icon"
                width="48px"
                height="48px"
            />

            <span className="my-3 text-center d-flex flex-column gap-1">
                <div>
                    <span className="text-meili weight-500">Click to upload</span> or drag and drop
                </div>
                <span style={{ color: 'gray', fontWeight: '400', fontSize: '14px' }}>
                    Max. size 50MB
                </span>
            </span>
            <input
                className="d-none"
                ref={inputFile}
                onChange={handleUploadClick}
                type="file"
                multiple="multiple"
            />
        </div>
    )
}

export default UploadImage
